import { liteClient as algoliasearch } from "algoliasearch/lite";

export function initSearch(initialSearch = true) {
  // if (initSearch?.client) {
  //   return initSearch.client;
  // }
  let firstLoad = true;

  const client = algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
    process.env.NEXT_PUBLIC_ALGOLIA_API_KEY,

    {
      // hostsCache: createFallbackableCache({
      //   caches: [
      //     createBrowserLocalStorageCache({
      //       key: `${version}-${process.env.NEXT_PUBLIC_ALGOLIA_APP_ID}`,
      //     }),
      //     createInMemoryCache(),
      //   ],
      // }),
      // search(requests) {
      //   if (requests.every(({ params }) => !params.query) && !initialSearch) {
      //     firstLoad = false;
      //     return;
      //   }
      //   return algoliaClient.search(requests);
      // },
    }
  );

  return client;
}

export function initCustomSearch() {
  const client = algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
    process.env.NEXT_PUBLIC_ALGOLIA_API_KEY,

    {
      // requestsCache: createInMemoryCache({ serializable: false }),
      // responsesCache: createInMemoryCache(),
      // hostsCache: createFallbackableCache({
      //   caches: [
      //     createBrowserLocalStorageCache({
      //       key: `${version}-${process.env.NEXT_PUBLIC_ALGOLIA_APP_ID}`,
      //     }),
      //     createInMemoryCache(),
      //   ],
      // }),
    }
  );

  const customClient = {
    ...client,
    search(requests) {
      if (requests[0].params.query === "empty-search-trigger") {
        requests.forEach((request) => (request.params.query = ""));
        return client.search(requests);
      }

      if (requests.every(({ params }) => !params.query)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
            hitsPerPage: 0,
            exhaustiveNbHits: false,
            query: "",
            params: "",
          })),
        });
      }

      // const requestsArray = [];

      // for (let i = requests.length - 1; i >= 0; i--) {
      //   const hasRequest = requestsArray?.find((request) => {
      //     return request.indexName === requests[i].indexName;
      //   });

      //   if (!hasRequest) {
      //     requestsArray.push(requests[i]);
      //   }
      // }

      return client.search(requests);
    },
  };

  return customClient;
}

// export async function search(value, client) {
//   const searchText = value;

//   const indices = await client.listIndices();
//   const query = indices.items.map((ind) => {
//     return { indexName: ind.name, query: searchText };
//   });

//   const { results } = await client.multipleQueries(query);
//   return results;
// }
